import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function Card({ children, className, ...rest }: CardProps) {
  const classes = ["qr-card"];
  if (className) classes.push(className);

  return (
    <section className={classes.join(" ")} {...rest}>
      {children}
    </section>
  );
}

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardHeader({ children, className, ...rest }: CardHeaderProps) {
  const classes = ["qr-card-header"];
  if (className) classes.push(className);

  return (
    <div className={classes.join(" ")} {...rest}>
      {children}
    </div>
  );
}

export interface CardTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  /** Başlık seviyesi — sayfa başlığı için "h2", bir Card içindeki bölüm başlığı için "h3". */
  as?: "h2" | "h3";
  children: ReactNode;
}

export function CardTitle({
  as: Tag = "h2",
  children,
  className,
  ...rest
}: CardTitleProps) {
  const classes = ["qr-card-title"];
  if (className) classes.push(className);

  return (
    <Tag className={classes.join(" ")} {...rest}>
      {children}
    </Tag>
  );
}

export interface CardDescriptionProps
  extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function CardDescription({
  children,
  className,
  ...rest
}: CardDescriptionProps) {
  const classes = ["qr-card-description"];
  if (className) classes.push(className);

  return (
    <p className={classes.join(" ")} {...rest}>
      {children}
    </p>
  );
}

export interface CardContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardContent({
  children,
  className,
  ...rest
}: CardContentProps) {
  const classes = ["qr-card-content"];
  if (className) classes.push(className);

  return (
    <div className={classes.join(" ")} {...rest}>
      {children}
    </div>
  );
}

export interface CardFooterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function CardFooter({ children, className, ...rest }: CardFooterProps) {
  const classes = ["qr-card-footer"];
  if (className) classes.push(className);

  return (
    <div className={classes.join(" ")} {...rest}>
      {children}
    </div>
  );
}
